import type OofRollUpViewState from 'owa-mail-reading-pane-store/lib/store/schema/OofRollUpViewState';
import { OOF_ITEM_CLASS_REGEX } from 'owa-mail-store/lib/utils/constants';
import mailStore from 'owa-mail-store/lib/store/Store';

export function createOofRollUpViewState(itemClass: string): OofRollUpViewState {
    return {
        isOofItem: OOF_ITEM_CLASS_REGEX.test(itemClass),
        oofReplyNodeIds: [],
        isOofRollUpExpanded: mailStore().shouldExpandAllItemParts,
    };
}
